export const FILTER_INTERNAL_MARKETERS = 'FILTER_INTERNAL_MARKETERS';
export type FILTER_INTERNAL_MARKETERS = typeof FILTER_INTERNAL_MARKETERS;

export interface FilterInternalMarketers {
    type: FILTER_INTERNAL_MARKETERS;
}

export function filterInternalMarketersAction(): FilterInternalMarketers {
    return {
        type: FILTER_INTERNAL_MARKETERS
    };
}
